/**-----------------------------------------------------------------------------------------
* Copyright © 2021 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the project root for more information
*-------------------------------------------------------------------------------------------*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var core_1 = require("@angular/core");
var kendo_angular_l10n_1 = require("@progress/kendo-angular-l10n");
var messages_1 = require("./messages");
/**
 * @hidden
 */
var TimePickerLocalizedMessagesDirective = /** @class */ (function (_super) {
    tslib_1.__extends(TimePickerLocalizedMessagesDirective, _super);
    function TimePickerLocalizedMessagesDirective(service) {
        var _this = _super.call(this) || this;
        _this.service = service;
        return _this;
    }
    TimePickerLocalizedMessagesDirective_1 = TimePickerLocalizedMessagesDirective;
    var TimePickerLocalizedMessagesDirective_1;
    TimePickerLocalizedMessagesDirective = TimePickerLocalizedMessagesDirective_1 = tslib_1.__decorate([
        core_1.Directive({
            providers: [
                {
                    provide: messages_1.TimePickerMessages,
                    useExisting: core_1.forwardRef(function () { return TimePickerLocalizedMessagesDirective_1; }) // tslint:disable-line:no-forward-ref
                }
            ],
            selector: '[kendoTimePickerLocalizedMessages]'
        }),
        tslib_1.__metadata("design:paramtypes", [kendo_angular_l10n_1.LocalizationService])
    ], TimePickerLocalizedMessagesDirective);
    return TimePickerLocalizedMessagesDirective;
}(messages_1.TimePickerMessages));
exports.TimePickerLocalizedMessagesDirective = TimePickerLocalizedMessagesDirective;
